import { render, staticRenderFns } from "./ChatContact.vue?vue&type=template&id=37a9a125&scoped=true"
import script from "./ChatContact.vue?vue&type=script&lang=js"
export * from "./ChatContact.vue?vue&type=script&lang=js"
import style0 from "./ChatContact.vue?vue&type=style&index=0&id=37a9a125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a9a125",
  null
  
)

export default component.exports